import styled from 'styled-components';

import { Hint } from '~/styles';

export const HintLink = styled(Hint)`
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s;

  &:hover {
    color: ${({ theme }) => theme.secondary.blendToBackground(800)};
  }
`;
